<template>
  <div id="app">
    <my-navbar />
    <transition name="fade">
    <router-view></router-view>
    </transition>
    <my-footer />
  </div>
</template>

<script>
import myNavbar from './components/Navbar'
import myFooter from './components/Footer'

export default {
  components: {
    myNavbar,
    myFooter
  }
}
</script>

<style lang="css" scoped>
@media screen and (max-width: 767px) {
.fade-enter-active, .fade-leave-active {
  transition: all 0.5s;
}

.fade-enter, .fade-leave {
  opacity: 0;
  color: transparent
}
}

@media screen and (min-width: 768px) {
.fade-enter-active, .fade-leave-active {
  transition: all 0.9s;
}

.fade-enter, .fade-leave {
  opacity: 0;
  color: transparent
}
}
</style>



// WEBPACK FOOTER //
// src/App.vue